export const siteLinks = {
  bookingUrl: 'https://calendly.com/browsjungle/5hours',
  consultationUrl: 'https://calendly.com/browsjungle/4-5hours',
  instagramUrl: 'https://www.instagram.com/browsjungle/',
  googleUrl: 'https://g.page/brows-jungle?share',
  facebookUrl: 'https://www.facebook.com/browsjungles',
  mapsUrl: 'https://maps.google.com/?q=2795+Cabot+Dr+Suite+27+Corona+CA+92883',
  email: 'browsjungle@gmail.com',
  emailHref: 'mailto:browsjungle@gmail.com',
  phone: '(747) 224-7451',
  phoneHref: 'tel:+17472247451',
  address1: '2795 Cabot Dr, Suite 27',
  address2: 'Corona, CA 92883',
};

const consentLinks = [
  {
    href: 'https://drive.google.com/file/d/1PCWapELgGw6y9ZW7CJ5Egq-5OXbtRuGV/view?usp=sharing',
    tr: 'İşlem Öncesi Kaş Bakımı',
    en: 'Before The Procedure - Brows',
  },
  {
    href: 'https://drive.google.com/file/d/1KWMuoN9QNdrOjV9QYik_ZSYMZHjWhuha/view?usp=sharing',
    tr: 'İşlem Öncesi Dudak Bakımı',
    en: 'Before The Procedure - Lips',
  },
  {
    href: 'https://drive.google.com/file/d/1W1e-_ym4Mx2L0ssPBPuwYiJ96S9eXSyH/view?usp=sharing',
    tr: 'Ana Onam Formu',
    en: 'Main Consent Form',
  },
  {
    href: 'https://drive.google.com/file/d/1zakpDsnXHZea6ff756unhtNfN9_gqFgC/view?usp=sharing',
    tr: 'Medikal Onam ve İşlem Çizelgesi',
    en: 'Medical Consent and Procedure Chart',
  },
  {
    href: 'https://drive.google.com/file/d/1WJ-F8_RmXtsWZUT6AdklEnjIo1xBcyai/view?usp=sharing',
    tr: 'Fotoğraf ve Sorumluluk İzin Formu',
    en: 'Photo and Liability Release Form',
  },
  {
    href: 'https://drive.google.com/file/d/1YyXYIGB8Gj8W93LorYz2U_iUWPjWe-PK/view?usp=sharing',
    tr: 'İşlem Sonrası Kaş Bakımı',
    en: 'After The Procedure - Brows',
  },
  {
    href: 'https://drive.google.com/file/d/14D0Ew3CIESUeUnbaINS6scU3KIh9at-F/view?usp=sharing',
    tr: 'İşlem Sonrası Dudak Bakımı',
    en: 'After The Procedure - Lips',
  },
  {
    href: 'https://drive.google.com/file/d/1zlDWps3F8cAqVegLOA_-DhpVQEZ_FkFe/view?usp=sharing',
    tr: 'İşlem Raporu',
    en: 'Procedure Report',
  },
];

const pricingItems = [
  {
    price: '$425',
    title: { tr: 'Lip Blush', en: 'Lip Blush' },
    text: {
      tr: 'Dudak formunu belirginleştiren ve tona canlılık katan yumuşak renk uygulaması.',
      en: 'A soft lip tint service that enhances the shape and vitality of the lips.',
    },
  },
  {
    price: '$425',
    title: { tr: 'Powder Brows', en: 'Powder Brows' },
    text: {
      tr: 'Daha dolgun ve gölgeli kaş görünümü isteyenler için ideal seçenek.',
      en: 'A soft shaded brow look for clients who want a fuller finish.',
    },
  },
  {
    price: '$425',
    title: { tr: 'Microblading', en: 'Microblading' },
    text: {
      tr: 'Doğal kıl efekti görünümü isteyen uygun cilt tipleri için tercih edilir.',
      en: 'Great for selected skin types looking for a natural hair-stroke effect.',
    },
  },
  {
    price: '$425',
    title: { tr: 'Combo Brows', en: 'Combo Brows' },
    text: {
      tr: 'Kıl efekti ile gölgeli dolgunluğu bir araya getiren karma teknik.',
      en: 'A balanced combination of hair-strokes and soft shading.',
    },
  },
];

const touchUps = [
  {
    price: '$120',
    title: { tr: 'Touch-up', en: 'Touch-up' },
    text: { tr: 'İlk seanstan 1-3 ay sonra.', en: '1 to 3 months after the first session.' },
  },
  {
    price: '$150',
    title: { tr: 'Yıllık Touch-up', en: 'Annual Touch-up' },
    text: { tr: 'Son touch-up işleminden 6-12 ay sonra.', en: '6 to 12 months after the last touch-up.' },
  },
  {
    price: '$200',
    title: { tr: 'İki Yıllık Touch-up', en: 'Biannual Touch-up' },
    text: { tr: 'Son touch-up işleminden 12-24 ay sonra.', en: '12 to 24 months after the last touch-up.' },
  },
];

export const content = {
  tr: {
    meta: {
      title: 'Brows Jungle | PMU Güzellik Stüdyosu',
      description: 'Türkçe varsayılan dil ve İngilizce destekle PMU brows ve lip blush hizmetleri.',
    },
    common: {
      bookNow: 'Randevu Al',
      contact: 'İletişim',
      details: 'Detayları Gör',
      pricing: 'Fiyatlar',
      gallery: 'Galeri',
      directions: 'Yol tarifi al',
    },
    header: {
      brand: 'Brows Jungle',
      tagline: 'PMU & güzellik stüdyosu',
      language: 'Dil',
      nav: [
        { label: 'Anasayfa', to: '/' },
        { label: 'Hakkımda', to: '/about' },
        { label: 'Ön Bilgilendirme', to: '/before-booking' },
        { label: 'Fiyatlar', to: '/pricing' },
        { label: 'Galeri', to: '/gallery' },
        { label: 'İletişim', to: '/contact' },
      ],
    },
    hero: {
      eyebrow: 'Doğal görünümlü kalıcı makyaj',
      title: 'Kaş ve dudak tasarımında zarif, modern ve güven veren sonuçlar',
      text: 'Corona, California’da kişiye özel PMU brows ve lip blush uygulamaları sunuyoruz.',
      badges: ['Hijyen odaklı', 'Kişiye özel tasarım', 'Türkçe ve İngilizce destek'],
      stats: [
        { value: '4+', label: 'öne çıkan hizmet' },
        { value: '1:1', label: 'kişisel danışmanlık' },
        { value: '2', label: 'dil seçeneği' },
      ],
    },
    services: {
      title: 'Öne çıkan hizmetler',
      text: 'Size uygun hizmeti seçin ve detay sayfasından hazırlık ile bakım adımlarını inceleyin.',
      items: [
        { title: 'PMU Brows', text: 'Microblading, powder brows ve combo brows.', to: '/pmu-brows' },
        { title: 'Lip Blush', text: 'Dudak tonunu ve konturu yumuşak biçimde belirginleştirir.', to: '/lip-blush' },
        { title: 'Fiyatlandırma', text: 'Hizmet fiyatları ve touch-up seçenekleri.', to: '/pricing' },
        { title: 'Galeri', text: 'Gerçek sonuçları ve stil örneklerini görüntüleyin.', to: '/gallery' },
      ],
    },
    home: {
      tag: 'Neden Brows Jungle?',
      title: 'Sade süreç, net bilgi, estetik sonuç',
      text: 'Her adımda güven veren, bakımı anlaşılır ve sonucu doğal görünen bir deneyim hedeflenir.',
      highlights: [
        { title: 'Yüzünüze özel tasarım', text: 'Form ve ton tercihleri size özel planlanır.' },
        { title: 'Şeffaf süreç', text: 'İşlem öncesi ve sonrası beklenti açıkça paylaşılır.' },
        { title: 'Doğal görünüm', text: 'Amaç daha bakımlı ama abartısız bir sonuçtur.' },
      ],
      processTitle: 'Süreç nasıl ilerler?',
      process: [
        { title: 'Ön değerlendirme', text: 'Uygunluk ve hedef görünüm netleştirilir.' },
        { title: 'Randevu planlama', text: 'Takvim, depozito ve onam adımları tamamlanır.' },
        { title: 'Bakım ve touch-up', text: 'İyileşme süreci ve gerekirse touch-up planlanır.' },
      ],
      quote: 'Kalıcı makyajda en iyi sonuç, doğru teknik kadar doğru iletişimle gelir.',
    },
    about: {
      tag: 'Hakkımda',
      title: 'Merhaba, ben Erika',
      text: 'Detay odaklı ve doğal görünüme önem veren bir PMU deneyimi sunuyorum.',
      paragraphs: [
        'Kaş ve dudak formunun yüz ifadesini değiştirdiğine inanıyorum; bu yüzden her işlem kişiye özel planlanır.',
        'Kaliteli ürünler ve modern tekniklerle güven veren, sakin ve profesyonel bir randevu akışı hedeflenir.',
        'Amacım yalnızca estetik bir dokunuş değil, baştan sona anlaşılır ve konforlu bir deneyim sunmaktır.',
      ],
      values: [
        { title: 'Detay odaklı', text: 'Simetri, ton ve form kararları aceleye getirilmez.' },
        { title: 'Hijyen & konfor', text: 'Temiz ve profesyonel bir ortam önceliklidir.' },
        { title: 'Doğal sonuç', text: 'Yüzünüze uyumlu, yumuşak bir görünüm hedeflenir.' },
      ],
    },
    consent: {
      tag: 'Randevu öncesi',
      title: 'Randevu almadan önce 3 adımı tamamlayın',
      text: 'Daha sorunsuz bir süreç için aşağıdaki adımları ve PDF dosyalarını inceleyin.',
      steps: [
        '50$ iade edilemez depozito gönderin. Bu tutar işlem ücretinize yansıtılır.',
        'Ad-soyad ve filtresiz tam yüz fotoğrafı paylaşın. Uygunluk onayı sonrası rezervasyon netleşir.',
        'Bilgilendirme ve onam formlarını okuyarak işlem öncesi ile sonrası kuralları gözden geçirin.',
      ],
      documentsTitle: 'PDF dosyaları',
      documents: consentLinks.map((item) => ({ href: item.href, label: item.tr })),
    },
    contact: {
      tag: 'İletişim',
      title: 'Randevunuzu planlayın',
      text: 'Sorularınız için bize ulaşabilir veya aşağıdaki takvimden uygun saati seçebilirsiniz.',
      bookingTitle: 'Online randevu',
      infoTitle: 'İletişim bilgileri',
      hours: 'Sadece randevu ile',
      follow: 'Sosyal medya',
    },
    galleryPage: {
      tag: 'Galeri',
      title: 'Gerçek uygulama sonuçları',
      text: 'Farklı teknikler ve cilt tipleri için elde edilen sonuçları inceleyin.',
    },
    pricingPage: {
      tag: 'Fiyatlar',
      title: 'Hizmetler ve fiyatlandırma',
      text: 'Başlangıç fiyatları ve touch-up seçenekleri aşağıdadır.',
      items: pricingItems.map((item) => ({ title: item.title.tr, text: item.text.tr, price: item.price })),
      touchUpsTitle: 'Touch-up seçenekleri',
      touchUpsText: 'İyileşme sonrası renk ve yoğunluğu dengelemek için touch-up önemlidir.',
      touchUps: touchUps.map((item) => ({ title: item.title.tr, text: item.text.tr, price: item.price })),
      note: 'Randevuyu rezerve etmek için 50$ iade edilemez depozito gereklidir.',
    },
    brows: {
      tag: 'PMU Brows',
      title: 'Kaş işlemleri için uygun aday mısınız?',
      text: 'En uygun teknik cilt tipi, yüz oranı ve istediğiniz sonuca göre belirlenir.',
      candidateTitle: 'Kaş teknikleri',
      candidates: [
        { title: 'Microblading', text: 'Doğal kıl efekti isteyen uygun cilt tipleri için.' },
        { title: 'Powder Brows', text: 'Daha dolgun ve yumuşak gölgeli görünüm için.' },
        { title: 'Combo Brows', text: 'Kıl efekti ve gölgelendirmenin birleşimi.' },
      ],
      cautionTitle: 'Aşağıdaki durumlarda işlem uygulanmaz',
      cautions: [
        'Aktif cilt tahrişi, sedef, güneş yanığı veya akne',
        'Kalp pili, ciddi kalp rahatsızlığı veya lidokaine alerji',
        'Yakın dönemde botoks ya da Accutane kullanımı',
        'Hamilelik, emzirme, keloid eğilimi veya organ nakli öyküsü',
      ],
      beforeTitle: 'İşlem öncesi',
      before: [
        { title: '24 saat önce', text: 'Alkol, kafein ve kan sulandırıcı etkili takviyelerden kaçının.' },
        { title: '1 hafta önce', text: 'Güneşlenme, solaryum ve kaş işlemlerini bırakın.' },
        { title: '2-4 hafta önce', text: 'AHA, retinol ve yoğun cilt yenileyici ürünleri bırakın.' },
      ],
      afterTitle: 'İşlem sonrası',
      after: [
        { title: 'İlk 24 saat', text: 'Bölgeyi kuru tutun ve dokunmayın.' },
        { title: '24 saat sonrası', text: 'Nazik temizlik ve ince bakım ürünü uygulayın.' },
        { title: 'İyileşme boyunca', text: 'Kabukları koparmayın ve bölgeyi koruyun.' },
      ],
    },
    lips: {
      tag: 'Lip Blush',
      title: 'Lip blush için uygun aday mısınız?',
      text: 'Lip blush, dudak konturunu belirginleştiren ve daha canlı bir ton sağlayan yarı kalıcı uygulamadır.',
      candidateTitle: 'Lip blush hakkında',
      candidates: [
        { title: 'Doğal renk canlandırma', text: 'Amaç dudakları doğal çizgisinde rafine etmektir.' },
        { title: 'Yumuşak bitiş', text: 'Sonuç çoğu zaman hafif mat ve günlük kullanıma uygundur.' },
        { title: 'Kalıcılık', text: 'Genellikle 2-3 yıl kalıcılık sağlar.' },
      ],
      cautionTitle: 'Aşağıdaki durumlarda işlem uygulanmaz',
      cautions: [
        'Sık uçuk çıkarma öyküsü ve gerekli medikal önlemin alınmaması',
        'Hiperpigmentasyona eğilimli dudak yapısı için ek değerlendirme gereksinimi',
        'Aktif cilt tahrişi, güneş yanığı veya enfeksiyon',
        'Hamilelik, emzirme, 18 yaş altı veya kan sulandırıcı kullanımı',
      ],
      beforeTitle: 'İşlem öncesi',
      before: [
        { title: '24 saat önce', text: 'Alkol, kafein ve kan sulandırıcı etkili takviyelerden kaçının.' },
        { title: '1 hafta önce', text: 'Güneşlenme ve dudak üstü ağda veya ip işlemlerini bırakın.' },
        { title: '2-4 hafta önce', text: 'AHA, retinol, kimyasal peeling ve dolgu işlemlerini erteleyin.' },
      ],
      afterTitle: 'İşlem sonrası',
      after: [
        { title: '1-2. gün', text: 'Bölgeyi nazikçe temizleyin ve önerilen bakım ürününü kullanın.' },
        { title: '2-7. gün', text: 'Bölgeyi temiz tutun, kabuk oluşumunu zorlamayın.' },
        { title: 'Kaçınılacaklar', text: 'Makyaj, sauna, havuz, yoğun terleme ve direkt güneşten kaçının.' },
      ],
    },
    footer: {
      text: 'Brows Jungle, kişiye özel PMU brows ve lip blush hizmetlerini modern ve güven veren bir yaklaşımla sunar.',
      rights: 'Tüm hakları saklıdır.',
      follow: 'Takip edin',
    },
  },
  en: {
    meta: {
      title: 'Brows Jungle | PMU Beauty Studio',
      description: 'PMU brows and lip blush services with Turkish default language and full English support.',
    },
    common: {
      bookNow: 'Book Now',
      contact: 'Contact',
      details: 'Learn More',
      pricing: 'Pricing',
      gallery: 'Gallery',
      directions: 'Get directions',
    },
    header: {
      brand: 'Brows Jungle',
      tagline: 'PMU & beauty studio',
      language: 'Language',
      nav: [
        { label: 'Home', to: '/' },
        { label: 'About', to: '/about' },
        { label: 'Before Booking', to: '/before-booking' },
        { label: 'Pricing', to: '/pricing' },
        { label: 'Gallery', to: '/gallery' },
        { label: 'Contact', to: '/contact' },
      ],
    },
    hero: {
      eyebrow: 'Natural-looking permanent makeup',
      title: 'Elegant, modern results for brows and lips',
      text: 'We provide personalized PMU brows and lip blush services in Corona, California.',
      badges: ['Hygiene focused', 'Customized design', 'Turkish and English support'],
      stats: [
        { value: '4+', label: 'featured services' },
        { value: '1:1', label: 'personal consultation' },
        { value: '2', label: 'language options' },
      ],
    },
    services: {
      title: 'Featured services',
      text: 'Choose the right service and review the preparation and aftercare details.',
      items: [
        { title: 'PMU Brows', text: 'Microblading, powder brows, and combo brows.', to: '/pmu-brows' },
        { title: 'Lip Blush', text: 'A soft service to enhance lip color and contour.', to: '/lip-blush' },
        { title: 'Pricing', text: 'Service rates and touch-up options.', to: '/pricing' },
        { title: 'Gallery', text: 'Browse real results and visual references.', to: '/gallery' },
      ],
    },
    home: {
      tag: 'Why Brows Jungle?',
      title: 'A clear process and refined results',
      text: 'Each step is designed to feel organized, transparent, and naturally beautiful.',
      highlights: [
        { title: 'Customized design', text: 'Shape and tone choices are tailored to you.' },
        { title: 'Transparent process', text: 'Expectations are shared clearly before and after treatment.' },
        { title: 'Natural finish', text: 'The goal is a polished look without feeling overdone.' },
      ],
      processTitle: 'How the process works',
      process: [
        { title: 'Initial review', text: 'Suitability and goals are clarified first.' },
        { title: 'Booking flow', text: 'Calendar, deposit, and consent steps are completed.' },
        { title: 'Aftercare and touch-up', text: 'Healing and maintenance are planned clearly.' },
      ],
      quote: 'The best permanent makeup results come from technique, clarity, and good aftercare.',
    },
    about: {
      tag: 'About',
      title: 'Hi, I am Erika',
      text: 'I focus on a detail-driven PMU experience with natural-looking results.',
      paragraphs: [
        'Brows and lip tone can completely change the way the face is framed, so every treatment is planned around balance and harmony.',
        'I work with modern techniques and quality products to offer a calm, professional appointment experience.',
        'My goal is to deliver not only a beautiful result but also a process that feels clear and comfortable from start to finish.',
      ],
      values: [
        { title: 'Detail focused', text: 'Symmetry, tone, and shape decisions are never rushed.' },
        { title: 'Hygiene & comfort', text: 'A clean and professional environment comes first.' },
        { title: 'Natural result', text: 'The finish should feel soft, balanced, and wearable.' },
      ],
    },
    consent: {
      tag: 'Before booking',
      title: 'Complete these 3 steps before booking',
      text: 'Review the steps and PDF files below for a smoother booking process.',
      steps: [
        'Send a $50 non-refundable deposit. This amount goes toward your procedure price.',
        'Share your full name and a clear full-face photo. Booking is confirmed after approval.',
        'Read the consent and care forms to review the rules before and after treatment.',
      ],
      documentsTitle: 'PDF files',
      documents: consentLinks.map((item) => ({ href: item.href, label: item.en })),
    },
    contact: {
      tag: 'Contact',
      title: 'Plan your appointment',
      text: 'Reach out directly for questions or choose a suitable time from the calendar below.',
      bookingTitle: 'Online booking',
      infoTitle: 'Contact details',
      hours: 'By appointment only',
      follow: 'Social media',
    },
    galleryPage: {
      tag: 'Gallery',
      title: 'Real treatment results',
      text: 'Explore results across different techniques, tones, and client needs.',
    },
    pricingPage: {
      tag: 'Pricing',
      title: 'Services and pricing',
      text: 'Starting prices and touch-up options are listed below.',
      items: pricingItems.map((item) => ({ title: item.title.en, text: item.text.en, price: item.price })),
      touchUpsTitle: 'Touch-up options',
      touchUpsText: 'Touch-ups help balance color and intensity after healing.',
      touchUps: touchUps.map((item) => ({ title: item.title.en, text: item.text.en, price: item.price })),
      note: 'A $50 non-refundable deposit is required to reserve your appointment.',
    },
    brows: {
      tag: 'PMU Brows',
      title: 'Are you a good candidate for brow services?',
      text: 'The right technique depends on skin type, facial balance, and your desired finish.',
      candidateTitle: 'Brow techniques',
      candidates: [
        { title: 'Microblading', text: 'Ideal for selected skin types seeking a natural hair-stroke look.' },
        { title: 'Powder Brows', text: 'A fuller, softly shaded look for many skin types.' },
        { title: 'Combo Brows', text: 'A balanced mix of hair strokes and soft shading.' },
      ],
      cautionTitle: 'Treatment is not performed in these cases',
      cautions: [
        'Active skin irritation, psoriasis, sunburn, or acne near the area',
        'Pacemaker, major heart issues, or lidocaine allergy',
        'Recent Botox or Accutane use',
        'Pregnancy, nursing, keloid tendency, or organ transplant history',
      ],
      beforeTitle: 'Before the procedure',
      before: [
        { title: '24 hours before', text: 'Avoid alcohol, caffeine, and blood-thinning supplements.' },
        { title: '1 week before', text: 'Avoid sun exposure, tanning, and brow maintenance services.' },
        { title: '2-4 weeks before', text: 'Pause AHA, retinol, and intensive resurfacing products.' },
      ],
      afterTitle: 'After the procedure',
      after: [
        { title: 'First 24 hours', text: 'Keep the area dry and avoid touching it.' },
        { title: 'After 24 hours', text: 'Clean gently and apply a thin layer of aftercare product.' },
        { title: 'During healing', text: 'Do not pick scabs and protect the area carefully.' },
      ],
    },
    lips: {
      tag: 'Lip Blush',
      title: 'Are you a good candidate for lip blush?',
      text: 'Lip blush adds definition to the lip contour and a soft boost of natural color.',
      candidateTitle: 'About lip blush',
      candidates: [
        { title: 'Natural color refresh', text: 'The goal is to refine the natural lip line, not overdraw it.' },
        { title: 'Soft finish', text: 'Results often look subtle, matte, and easy to wear daily.' },
        { title: 'Longevity', text: 'Results commonly last around 2 to 3 years.' },
      ],
      cautionTitle: 'Treatment is not performed in these cases',
      cautions: [
        'Frequent cold sores without proper medical prevention',
        'Lip structure that may need extra hyperpigmentation assessment',
        'Active irritation, sunburn, or infection near the area',
        'Pregnancy, nursing, being under 18, or using blood thinners',
      ],
      beforeTitle: 'Before the procedure',
      before: [
        { title: '24 hours before', text: 'Avoid alcohol, caffeine, and blood-thinning supplements.' },
        { title: '1 week before', text: 'Avoid sun exposure and upper-lip waxing or threading.' },
        { title: '2-4 weeks before', text: 'Pause AHA, retinol, peels, and filler-related services.' },
      ],
      afterTitle: 'After the procedure',
      after: [
        { title: 'Days 1-2', text: 'Clean gently and follow the recommended aftercare plan.' },
        { title: 'Days 2-7', text: 'Keep the area clean and do not force peeling.' },
        { title: 'Avoid', text: 'Avoid makeup, sauna, swimming, heavy sweating, and direct sun.' },
      ],
    },
    footer: {
      text: 'Brows Jungle provides personalized PMU brows and lip blush services with a modern and reassuring approach.',
      rights: 'All rights reserved.',
      follow: 'Follow us',
    },
  },
};
